import apiClient from "../../../shared/infrastructure/api/client";
import { auth } from "../infrastructure/firebase";

/**
 * Refresh the signed-in user's ID token, so claims set by the server (such as
 * the MFA one) reach the next request.
 */
export async function refreshIdToken(): Promise<void> {
    await auth.currentUser?.getIdToken(true);
}

/**
 * Join the centre an invitation is for, once the new account's email is
 * verified. The call lives here rather than in the centre module so auth does
 * not depend on it: the centre module already depends on auth.
 */
export async function acceptCenterInvitation(token: string): Promise<void> {
    await apiClient.post(`/center-invitations/${token}/accept`);
}

/** Whether this browser has a signed-in Firebase user. */
export function hasSignedInUser(): boolean {
    return Boolean(auth.currentUser);
}

/** The signed-in user's email, if there is one. */
export function currentUserEmail(): string | null | undefined {
    return auth.currentUser?.email;
}

/** Reload the signed-in user and tell whether they have verified their email. */
export async function reloadEmailVerified(): Promise<boolean> {
    const currentUser = auth.currentUser;
    if (!currentUser) return false;
    await currentUser.reload();
    return Boolean(auth.currentUser?.emailVerified);
}
